<template>
  <v-row class="background-color-white full-width" justify="center" no-gutters>
    <v-col
      cols="8"
      lg="7"
      :style="style"
      v-if="products.length"
      class="
        background-color-white
        d-flex
        flex-column
        no-overflow
        results
        z-index-6
      "
      ref="searchResultsRef"
      @scroll="handleScroll"
    >
      <div v-for="product in products" :key="product.id">
        <Product :product="product" />
      </div>
      <div class="mb-12 text-center">
        <v-progress-circular
          v-show="!end"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-col>
    <v-col
      v-if="empty"
      cols="8"
      lg="7"
      class="
        align-center
        background-color-seashell
        d-flex
        font-color-black-magic font-weight-bold
        justify-center
        no-results-height
        results
        z-index-6
      "
      :class="bigBannerResults ? 'no-results-height-main' : 'no-results-height'"
      :style="style"
      >Your search did not match any products</v-col
    >
  </v-row>
</template>

<script>
import throttle from "lodash.throttle";
import { mapState } from "vuex";
import Product from "@/components/Search/Product.vue";

const styles = {
  absolutePosition: {
    maxHeight: "65vh",
    position: "absolute",
    top: "330px",
  },
  fixedPosition: {
    maxHeight: "92vh",
    position: "fixed",
    top: "58px",
  },
};

const getPixelsFromBottom = (searchResultsRef) => {
  if (!searchResultsRef) {
    return;
  }
  return (
    searchResultsRef.scrollHeight -
    searchResultsRef.scrollTop -
    searchResultsRef.offsetHeight
  );
};

const needMoreProducts = (searchResultsRef) => {
  const pixelsFromBottomToMakeAnotherRequest = 300;
  const pixelsFromBottom = getPixelsFromBottom(searchResultsRef);
  return pixelsFromBottom < pixelsFromBottomToMakeAnotherRequest;
};

export default {
  name: "SearchResults",
  components: { Product },
  computed: {
    ...mapState({
      empty: (state) => state.search.empty,
      end: (state) => state.search.end,
      products: (state) => state.search.products,
    }),
    style() {
      return this.bigBannerResults
        ? styles.absolutePosition
        : styles.fixedPosition;
    },
  },
  methods: {
    handleScroll: throttle(function () {
      const { searchResultsRef } = this.$refs;
      if (needMoreProducts(searchResultsRef)) {
        this.$store.commit("search/UPDATE_PAGE");
        this.$store.dispatch("search/fetchAndConcat");
      }
    }, 300),
  },
  props: { bigBannerResults: Boolean },
};
</script>

<style scoped lang="scss">
.no-results-height {
  font-size: 20px;
  height: 70px;
  background-color: #ddd;
  border: 2px solid #9c9c9c;
  &-main {
    width: 800px;
  }
}

.results {
  border-radius: 10px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.z-index-6 {
  z-index: 6;
}
</style>
